<template>
  <div class="content-item flex">
    <div class="content-item-label">文章级别</div>
    <el-radio-group
      v-model="level"
      class="flex align-items-center"
    >
      <el-radio :label="1">医生主页</el-radio>
      <el-radio :label="2">对外推广</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: "articleLevel",
  props: ['articleLevel'],
  computed: {
    level: {
      get() {
        return this.articleLevel
      },
      set(val) {
        this.$emit('update:articleLevel',val)
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
